import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { storageKeys } from 'settings';

import {
  APIHandler,
  DataHandler,
  Diploma,
  StorageHandler,
  TrainingGrid,
  ContentHeader,
  Progress,
} from 'C4';

const getTotalPages = (res) => {
  let totalPages = 0;
  const { chapters } = res.data[0];

  chapters.forEach((chapter) => {
    totalPages += chapter.total_pages;
  });
  return totalPages;
};

const calculateProgress = (progress, pages) => Math.floor((progress / pages) * 100);

// Dummy component used for simulating click on diploma button
const ViewDiploma = ({ diploma }) => {
  if (diploma !== 100) return null;

  const hasViewedDiploma = localStorage.getItem('hasViewedDiploma');
  if (hasViewedDiploma) return null;

  localStorage.setItem('hasViewedDiploma', true);
  document.getElementById('showDiplomaButton').click();

  return null;
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      email: '',
      firstName: '',
      lastName: '',
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    if (diploma >= 100) {
      const d = new Date(Date.now());
      const leading = val => `0${val}`.slice(-2);
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user.response.training_graduated === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
          DataHandler.matchAppId().then((appId) => {
            APIHandler.updateUser(appId, obj.response.email, [
              { param: 'sales_companion_registered', val: date },
              { param: 'training_started', val: date },
              { param: 'training_graduated', val: date },
            ]).then((res) => {
              if (res) {
                obj.response.sales_companion_registered = date;
                obj.response.training_started = date;
                obj.response.training_graduated = date;
                StorageHandler.save(storageKeys.user, obj);
              }
            });
          });
        }
      });
      StorageHandler.load(storageKeys.diplomaShown).then((res) => {
        if (!res) {
          this.frame('showDiploma');
          StorageHandler.save(storageKeys.diplomaShown, true);
        }
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getTotalProgress(res) {
    const { chapters } = res.data[0];
    let totalProgress = 0;

    chapters.forEach((chapter) => {
      totalProgress += chapter.progress;
    });

    this.setState({
      anyComplete: chapters.some((chapter) => chapter.progress === chapter.total_pages),
    });
    return totalProgress;
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        DataHandler.matchAppId().then((appId) => {
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email)).then(
            (userProgress) => {
              const totalProgress = this.getTotalProgress(userProgress);
              const totalPages = getTotalPages(userProgress);
              const percentage = calculateProgress(totalProgress, totalPages);
              this.setState({ totalProgressValue: percentage >= 100 ? 100 : percentage });
              this.setState({
                email,
              });

              if (percentage >= 100) {
                this.setState({ diploma: 100 });
              } else {
                this.setState({ diploma: 0 });
              }
            },
          );
          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName } = user.response;
            this.setState({
              firstName,
              lastName,
              appId,
            });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  render() {
    const { diploma, firstName, lastName, email, totalProgressValue, appId } = this.state;

    return (
      <div className="contentContainer trainingView">
        <ViewDiploma diploma={diploma} />
        <ContentHeader
          header={i18n.translate('contentHeaders.train')}
          subtitle={i18n.translate('pageDescriptions.train')}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <h6 className="progressText">{`${totalProgressValue}% Complete`}</h6>
              <Progress id="progress" value={totalProgressValue} />
            </div>
            <a
              id="showDiplomaButton" // id used for simulating click
              className={`container__progressDiploma ${
                totalProgressValue === 100 ? 'completed' : ''
              }`}
              role="button"
              tabIndex={-1}
              data-fancybox
              data-src="#diploma"
              data-options='{"toolbar" : "true", "buttons" : ["close"]}'
              href="javascript:;"
              style={{ pointerEvents: diploma === 100 ? 'auto' : 'none' }}
            >
              <FontAwesomeIcon icon={['far', 'file-certificate']} className={diploma === 100 ? 'completed' : ''} />

              <p className="text__viewDiploma">
                {diploma === 100 && i18n.translate('nav.reportCard')}
              </p>
            </a>
            <style>
              {
                '\
            .grv-widget-tag-bottom-right {\
              display: block !important;\
            } '
              }
            </style>
          </div>
        </ContentHeader>
        <TrainingGrid />
        <Diploma appId={appId} firstName={firstName} email={email} lastName={lastName} />
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  email: '',
  firstName: '',
  lastName: '',
};
